import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { PiDotsThree } from "react-icons/pi";
import BaseUrl from "../../Components/BaseUrl";
import {
  FaBookmark,
  FaRegBookmark,
  FaLink,
  FaEdit,
  FaTrash,
  FaCommentSlash,
} from "react-icons/fa";
import {
  MdClose,
  MdReply,
  MdThumbUp,
  MdKeyboardArrowUp,
  MdKeyboardArrowDown,
} from "react-icons/md";
import { BsFillCursorFill } from "react-icons/bs";
import EditPostModal from "../../Modals/EditPost/EditPostModal";
import { useNavigate } from "react-router-dom";
import EmojiPicker from "emoji-picker-react";


const LinkedInPoll = ({ pollData, onVote,currentUser, selectedOption }) => {
  const {
    id,
    question,
    options,
    totalVotes,
    user_name,
    user_profile,
    user_id,
    likes,
    has_liked,
    closes_at,
    created_at,
    slug,
    comments: pollComments,
    user_selected_option,
    is_saved,
  } = pollData;

  const initialComments = Array.isArray(pollComments) ? pollComments : [];
  const [showAllComments, setShowAllComments] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [showReplyEmojiPicker, setShowReplyEmojiPicker] = useState(false);
  const isPollClosed = new Date() > new Date(closes_at);
  const canVote = !isPollClosed && selectedOption !== null;
  const [showOptions, setShowOptions] = useState(false);
  const showOptionRef = useRef(null);
  const showButtonRef = useRef(null);
  const [isLiked, setIsLiked] = useState(has_liked);
  const [likeCount, setLikeCount] = useState(likes);
  const [comments, setComments] = useState(initialComments);
  const [commentLikes, setCommentLikes] = useState();
  const [commentisLiked, setCommentisLiked] = useState();
  const [showComments, setShowComments] = useState(false);
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyText, setReplyText] = useState("");
  const [showAllReplies, setShowAllReplies] = useState({});
  const [showEditPostModal, setShowEditPostModal] = useState(false);
  const [isSaved, setIsSaved] = useState(is_saved);
  const navigate = useNavigate();

  const commentInputRef = useRef(null);
  const replyInputRefs = useRef({});
const EmojiPickerWrapper = ({ onEmojiSelect, onClose, positionClass, inputRef }) => {
  const pickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  return (
    <div ref={pickerRef} className={`absolute z-50 ${positionClass}`}  >
      <EmojiPicker
        onEmojiClick={(emojiData) => {
          onEmojiSelect(emojiData.emoji);
          onClose();
          if (inputRef && inputRef.current) {
            inputRef.current.focus();
          }
        }}
        width={300}
        height={350}
      />
    </div>
  );
};

  const handleToggleSaveUnsave = async () => { 
    if (isSaved) {
      const response = await axios.post(
        `${BaseUrl}unsavepost`,
        {
          saved_type: "group_poll",
          savable_id: pollData.id,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );     
      if (response.data.status === 200) {
        setIsSaved(!isSaved);        
        navigate('/my-items/saved-post');
      }
      setShowOptions(false);
    } else {
      await axios.post(
        `${BaseUrl}savepost`,
        {
          saved_type: "group_poll",
          group_id: groupData.id,
          savable_id: post.id,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
    }
  };


  const formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    if (diffInSeconds < 60) return "Just now";
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
    if (diffInSeconds < 86400)
      return `${Math.floor(diffInSeconds / 3600)}h ago`;
    return `${Math.floor(diffInSeconds / 86400)}d ago`;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showOptions &&
        showOptionRef.current &&
        !showOptionRef.current?.contains(event.target) &&
        !showButtonRef.current?.contains(event.target)
      ) {
        setShowOptions(false);
      }
    };
    if (showOptions) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showOptions]);

  const getpollresults = async (pollid) => {
    setIsLoading(true);
    try {
      const response = await axios.get(BaseUrl + `getPollResults/${pollid}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleLike = async (e) => {
    e.preventDefault();
    try {
      if (isLiked) {
        await axios.post(
          `${BaseUrl}grouppollunlike/${pollData.group_id}/${pollData.id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
              Accept: "application/json",
            },
          }
        );
        setIsLiked(false);
        setLikeCount((prev) => prev - 1);
      } else {
        await axios.post(
          `${BaseUrl}grouppolllike/${pollData.group_id}/${pollData.id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
              Accept: "application/json",
            },
          }
        );
        setIsLiked(true);
        setLikeCount((prev) => prev + 1);
      }
    } catch (error) {
      console.log("Error toggling like:", error);
    }
  };
  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    if (!commentText.trim()) return;
    const tempComment = {
      comment_id: `temp-${Math.random().toString(36).substr(2, 9)}`, 
      comment: commentText.trim(),
      comment_user_name: currentUser.name,
      comment_user_profile: currentUser.profile_image,
      created_at: new Date().toISOString(),
      comment_likes: 0,
      has_liked_comment: false,
      replies: [],
      isTemporary: true, 
    };
    setComments((prev) => [tempComment, ...prev]);
    setCommentText("");
    try {
      const formData = new FormData();
      formData.append("comment", commentText);

      const response = await axios.post(
        BaseUrl + `pollComment/${pollData.group_id}/${pollData.id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );

      if (response.data.status === 200) {
              const serverComment = response.data.data;
              setComments((prev) =>
                prev.map((comment) =>
                  comment.comment_id === tempComment.comment_id
                    ? {
                        ...serverComment,
                        comment_user_name: currentUser.name, 
                        comment_user_profile: currentUser.profile_image,
                      }
                    : comment
                )
              );
            } else {
              setComments((prev) =>
                prev.filter((comment) => comment.comment_id !== tempComment.comment_id)
              );
              swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to post comment",
              });
            }
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };
  
  const handleCommentLike = async (isCurrentlyLiked, commentId) => {
    try {
      setComments((prevComments) =>
        prevComments.map((comment) => {
          // Check if this is the main comment being liked
          if (comment.comment_id === commentId) {
            return {
              ...comment,
              has_liked_comment: !isCurrentlyLiked,
              comment_likes: isCurrentlyLiked
                ? comment.comment_likes - 1
                : comment.comment_likes + 1,
            };
          }

          // Check if this comment has replies that might need updating
          if (comment.replies && comment.replies.length > 0) {
            const updatedReplies = comment.replies.map((reply) => {
              if (reply.comment_id === commentId) {
                return {
                  ...reply,
                  has_liked_comment: !isCurrentlyLiked,
                  comment_likes: isCurrentlyLiked
                    ? reply.comment_likes - 1
                    : reply.comment_likes + 1,
                };
              }
              return reply;
            });
            return { ...comment, replies: updatedReplies };
          }

          return comment;
        })
      );
      if (isCurrentlyLiked) {
        await axios.post(
          `${BaseUrl}grouppollcommentunlike/${commentId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
              Accept: "application/json",
            },
          }
        );
      } else {
        await axios.post(
          `${BaseUrl}grouppollcommentlike/${commentId}/${pollData.id}/${pollData.group_id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
              Accept: "application/json",
            },
          }
        );
      }
    } catch (error) {
      console.log("Error toggling like:", error);
      setComments((prevComments) =>
        prevComments.map((comment) => {
          if (comment.comment_id === commentId) {
            return {
              ...comment,
              has_liked_comment: isCurrentlyLiked,
              comment_likes: isCurrentlyLiked
                ? comment.comment_likes + 1
                : comment.comment_likes - 1,
            };
          }
          if (comment.replies && comment.replies.length > 0) {
            const updatedReplies = comment.replies.map((reply) => {
              if (reply.comment_id === commentId) {
                return {
                  ...reply,
                  has_liked_comment: isCurrentlyLiked,
                  comment_likes: isCurrentlyLiked
                    ? reply.comment_likes + 1
                    : reply.comment_likes - 1,
                };
              }
              return reply;
            });
            return { ...comment, replies: updatedReplies };
          }
          return comment;
        })
      );
    }
  };
  const handleReplySubmit = async (e, parentId) => {
    e.preventDefault();
    if (!replyText.trim()) return;
    const tempId = Math.floor(Math.random() * 100000);

    const newReply = {
      comment_id: tempId,
      comment: replyText,
      comment_user_name: currentUser.name,
      comment_user_profile: currentUser.profile_image,
      created_at: new Date().toISOString(),
      comment_likes: 0,
      has_liked_comment: false,
      comment_post_id: null,
      comment_user_id: currentUser.id,
      comment_parent_id: parentId,
      replies: [],
    };
    setComments((prevComments) =>
      prevComments.map((comment) => {
        if (comment.comment_id === parentId) {
          return {
            ...comment,
            replies: [...comment.replies, newReply],
          };
        }
        return comment;
      })
    );
    try {
      const formData = new FormData();
      formData.append("comment", replyText);

      const response = await axios.post(
        BaseUrl + `pollComment/${pollData.group_id}/${pollData.id}/${parentId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
      setReplyText("");
      setReplyingTo(null);
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };
  const onEmojiClick = (emojiData) => {
    setCommentText((prev) => prev + emojiData.emoji);
  };

  return (
    <div className="p-4 bg-white shadow rounded-lg">
      <div className="relative flex items-start justify-between space-x-3 mb-4">
        <div className="flex items-center space-x-3 mb-4">
          <div className="w-10 h-10 rounded-full overflow-hidden">
            {user_profile ? (
              <img
                src={user_profile}
                alt={user_name}
                className="w-full h-full object-cover border border-gray-200 rounded-full"
              />
            ) : (
              <div className="w-full h-full bg-gray-300 flex items-center justify-center text-white font-semibold text-lg">
                {user_name?.charAt(0)?.toUpperCase()}
              </div>
            )}
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">{user_name}</h3>
            <p className="text-xs text-gray-500">
              {/* {user.role} •{" "} */}
              {new Date(created_at).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
              })}
              {isPollClosed && " • Closed"}
            </p>
          </div>
        </div>
        <PiDotsThree
          className="text-2xl"
          onClick={() => setShowOptions(!showOptions)}
          ref={showButtonRef}
        />
        {showOptions && (
          <div
            ref={showOptionRef}
            className="absolute bg-white border border-gray-300 shadow-lg rounded-l-lg rounded-b-lg z-50 mt-5 w-72 right-0"
          >
            <button
              className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100"
              onClick={handleToggleSaveUnsave}
            >
              {isSaved ? <FaBookmark /> : <FaRegBookmark />}
              {isSaved ? "Unsave" : "Save"}
            </button>

            {/* <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100">
              <FaLink />
              Copy Link to Post
            </button>

            <button
              className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100"
              onClick={() => setShowEditPostModal(true)}
            >
              <FaEdit />
              Edit Post
            </button>

            <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100">
              <FaTrash />
              Delete Post
            </button>

            <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100">
              <FaCommentSlash />
              Disable Comments on this Post
            </button> */}
          </div>
        )}
      </div>

      <div className="border rounded-lg p-4">
        <h2 className="text-lg font-medium">{question}</h2>
        <p className="text-xs text-gray-500 mb-3">
          {canVote
            ? "You can see how people vote."
            : "This poll has ended. Here are the results."}{" "}
          <span className="text-blue-600 cursor-pointer">Learn more</span>
        </p>

        <div className="space-y-3 mb-4">
          {options?.map((option) => {
            const isSelected = selectedOption === option.id;
            const percentage = totalVotes > 0 ? option.percentage : 0;

            return (
              <button
                key={option.id}
                onClick={() => canVote && onVote(pollData.id, option.id, slug)}
                className={`w-full text-left p-3 rounded border transition-all ${
                  isSelected || user_selected_option === option.id
                    ? "border-blue-500 bg-blue-50"
                    : !canVote
                    ? "border-gray-200 opacity-70"
                    : "border-gray-200 hover:bg-gray-50"
                }`}
                disabled={!canVote || user_selected_option}
              >
                <div className="flex justify-between items-center mb-1">
                  <span
                    className={isSelected ? "font-medium text-blue-600" : ""}
                  >
                    {option.option_text}
                  </span>
                  {(!canVote || selectedOption !== null) && (
                    <span className="text-sm font-medium">{percentage}%</span>
                  )}
                </div>
                {(!canVote || selectedOption !== null) && (
                  <div className="w-full bg-gray-100 rounded-full h-2">
                    <div
                      className="h-full bg-blue-500 rounded-full"
                      style={{ width: `${percentage}%` }}
                    ></div>
                  </div>
                )}
              </button>
            );
          })}
        </div>
        <div className="flex justify-between text-sm text-gray-500 pt-2">
          <span>
            {totalVotes} votes • {isPollClosed ? "Poll closed" : "Voting open"}
          </span>
          {!isPollClosed && (
            <span>
              Closes at:{" "}
              {new Date(closes_at).toLocaleString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              })}
            </span>
          )}
        </div>
      </div>

      <div className="px-4 py-2 text-sm text-gray-500  border-b">
        <div className="flex items-center justify-between space-x-4">
          <span>
            {likeCount} {likeCount === 1 ? "like" : "likes"}
          </span>
          <span>
            {comments.length} {comments.length === 1 ? "comment" : "comments"}
          </span>
        </div>
      </div>

      <div className="flex justify-around py-2 text-gray-500">
        <button
          onClick={(e) => {
            handleLike(e);
          }}
          className={`flex items-center space-x-1 px-4 py-2 rounded-md hover:bg-gray-100 ${
            isLiked ? "text-blue-500" : ""
          }`}
        >
          <i
            className={`fas fa-thumbs-up ${isLiked ? "text-blue-500" : ""}`}
          ></i>
          <span>{isLiked ? "Liked" : "Like"}</span>
        </button>
        <button
          className="flex items-center space-x-1 px-4 py-2 rounded-md hover:bg-gray-100"
          onClick={() => {
            setShowComments(!showComments), setShowAllComments(false);
          }}
        >
          <i className="far fa-comment"></i>
          <span>Comment</span>
        </button>
      </div>

      {showComments && (
        <div className="border-t p-4">
          <form
            onSubmit={(e) => handleCommentSubmit(e)}
            className="relative flex items-start gap-3 mb-4"
          >
            {currentUser.profile_image ? (
              <img
                src={currentUser.profile_image}
                alt="user"
                className="w-8 h-8 rounded-full object-cover"
              />
            ) : (
              <div className="w-8 h-8 rounded-full bg-purple-500 text-white flex items-center justify-center font-semibold text-sm">
                {currentUser.name?.charAt(0).toUpperCase()}
              </div>
            )}
            <div className="flex-1">
              <div className="flex items-center border rounded-full w-full py-2 px-4 text-sm focus-within:ring-1 focus-within:ring-blue-500">
                <input
                  ref={commentInputRef}
                  type="text"
                  value={commentText}
                  onChange={(e) => setCommentText(e.target.value)}
                  placeholder="Add a comment..."
                  className="flex-1 outline-none bg-transparent"
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      handleCommentSubmit(e);
                    }
                  }}
                />
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    😊
                  </button>
                  {commentText.trim() && (
                    <button type="submit" className="text-blue-500 font-medium">
                      Post
                    </button>
                  )}
                </div>
              </div>
              {showEmojiPicker && (
                <EmojiPickerWrapper
                  onEmojiSelect={(emoji) =>
                    setCommentText((prev) => prev + emoji)
                  }
                  onClose={() => setShowEmojiPicker(false)}
                  positionClass="bottom-12 right-0"
                  inputRef={commentInputRef}
                />
              )}
            </div>
          </form>
          <div className="flex items-center justify-between mb-3 px-2">
            <div className="flex items-center">
              <h3 className="font-medium text-gray-800 text-[15px]">
                {comments.length}{" "}
                {comments.length === 1 ? "Comment" : "Comments"}
              </h3>
              {comments.length > 2 && !showAllComments && (
                <span className="ml-2 text-xs text-gray-500">
                  ({comments.length - 2} hidden)
                </span>
              )}
            </div>
            <button
              onClick={() => {
                setShowComments(!showComments), setShowAllComments(false);
              }}
              className="text-sm text-gray-600 hover:text-gray-800 flex items-center group"
            >
              <span className="group-hover:bg-gray-100 p-1.5 rounded-full">
                <MdClose className="text-lg" />
              </span>
            </button>
          </div>

          <div className="space-y-4">
            {comments
              .slice(0, showAllComments ? comments.length : 2)
              .map((comment) => (
                <div key={comment.comment_id} className="flex gap-3">
                  <div className="flex-shrink-0">
                    {comment.comment_user_profile ? (
                      <img
                        src={comment.comment_user_profile}
                        alt={comment.comment_user_name}
                        className="w-8 h-8 rounded-full object-cover border border-gray-200"
                      />
                    ) : (
                      <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-sm border border-gray-200">
                        {comment.comment_user_name?.[0]?.toUpperCase()}
                      </div>
                    )}
                  </div>

                  <div className="flex-1">
                    <div className="bg-gray-50 rounded-2xl p-3">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-1">
                          <p className="font-medium text-sm font-semibold text-gray-900 hover:underline hover:text-blue-600 cursor-pointer">
                            {comment.comment_user_name || "User"}
                          </p>
                          {comment.is_author && (
                            <span className="text-xs text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded-full">
                              Author
                            </span>
                          )}
                        </div>
                        <span className="text-xs text-gray-500">
                          {formatTimeAgo(comment.created_at)}
                        </span>
                      </div>

                      <p className="text-sm text-gray-800 mt-1 whitespace-pre-line">
                        {comment.comment}
                      </p>

                      <div className="flex items-center mt-2 text-xs text-gray-500">
                        <button
                          className={`flex items-center gap-1 hover:text-blue-600 ${
                            comment.has_liked_comment ? "text-blue-600" : ""
                          }`}
                          onClick={() =>
                            handleCommentLike(
                              comment.has_liked_comment,
                              comment.comment_id
                            )
                          }
                        >
                          <i
                            className={`fas fa-thumbs-up ${
                              comment.has_liked_comment ? "text-blue-500" : ""
                            }`}
                          ></i>
                          {comment.comment_likes > 0 && (
                            <span>{comment.comment_likes}</span>
                          )}
                          <span>Like</span>
                        </button>

                        <span className="mx-2 text-gray-800">|</span>

                        {/* Reply button - only show reply count if there are replies */}
                        <button
                          className="flex items-center gap-1 hover:text-blue-600"
                          onClick={() =>
                            setReplyingTo(
                              replyingTo === comment.comment_id
                                ? null
                                : comment.comment_id
                            )
                          }
                        >
                          <MdReply className="text-base" />
                          <span className="ml-1">Reply</span>
                          {comment.replies && comment.replies.length > 0 && (
                            <>
                              <span className="mx-1">•</span>
                              <span>{comment.replies.length}</span>
                              {comment.replies.length === 1
                                ? "reply"
                                : "replies"}
                            </>
                          )}
                        </button>
                      </div>
                    </div>

                    {/* Replies Section */}
                    {comment.replies && comment.replies.length > 0 && (
                      <div className="mt-2 ml-2 pl-4 border-l-2 border-gray-200">
                        {comment.replies
                          .slice(
                            0,
                            showAllReplies[comment.comment_id]
                              ? comment.replies.length
                              : 2
                          )
                          .map((reply) => (
                            <div
                              key={reply.comment_id}
                              className="flex gap-3 mt-3"
                            >
                              <div className="flex-shrink-0">
                                {reply.comment_user_profile ? (
                                  <img
                                    src={reply.comment_user_profile}
                                    alt={reply.comment_user_name}
                                    className="w-8 h-8 rounded-full object-cover border border-gray-200"
                                  />
                                ) : (
                                  <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-sm border border-gray-200">
                                    {reply.comment_user_name?.[0]?.toUpperCase()}
                                  </div>
                                )}
                              </div>

                              <div className="flex-1">
                                <div className="bg-gray-50 rounded-2xl p-3">
                                  <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-1">
                                      <p className="font-medium font-semibold text-sm text-gray-900 hover:underline hover:text-blue-600 cursor-pointer">
                                        {reply.comment_user_name || "User"}
                                      </p>
                                      {reply.is_author && (
                                        <span className="text-xs text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded-full">
                                          Author
                                        </span>
                                      )}
                                    </div>
                                    <span className="text-xs text-gray-500">
                                      {formatTimeAgo(reply.created_at)}
                                    </span>
                                  </div>

                                  <p className="text-sm text-gray-800 mt-1">
                                    {reply.comment}
                                  </p>

                                  <div className="flex items-center mt-2 text-xs text-gray-500 space-x-4">
                                    <button
                                      className={`flex items-center gap-1 hover:text-blue-600 ${
                                        reply.has_liked_comment
                                          ? "text-blue-600"
                                          : ""
                                      }`}
                                      onClick={() =>
                                        handleCommentLike(
                                          reply.has_liked_comment,
                                          reply.comment_id
                                        )
                                      }
                                    >
                                      <MdThumbUp className="icon" />
                                      {reply.comment_likes > 0 && (
                                        <span>{reply.comment_likes}</span>
                                      )}
                                      <span>Like</span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}

                        {comment.replies.length > 2 && (
                          <button
                            onClick={() =>
                              setShowAllReplies((prev) => ({
                                ...prev,
                                [comment.comment_id]: !prev[comment.comment_id],
                              }))
                            }
                            className="w-full text-left text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors mt-2"
                          >
                            <div className="inline-flex items-center px-4 py-1.5 rounded-full hover:bg-gray-100">
                              {showAllReplies[comment.comment_id] ? (
                                <>
                                  <MdKeyboardArrowUp className="mr-1 text-lg" />
                                  Collapse replies
                                </>
                              ) : (
                                <>
                                  <MdKeyboardArrowDown className="mr-1 text-lg" />
                                  See {comment.replies.length - 2} more{" "}
                                  {comment.replies.length - 2 === 1
                                    ? "reply"
                                    : "replies"}
                                </>
                              )}
                            </div>
                          </button>
                        )}
                      </div>
                    )}
                    {/* Reply Form */}
                    {replyingTo === comment.comment_id && (
                      <div className="mt-3 ml-2 pl-4 border-l-2 border-gray-200">
                        <form
                          onSubmit={(e) =>
                            handleReplySubmit(e, comment.comment_id)
                          }
                          className="flex gap-2 items-start"
                        >
                          {currentUser.profile_image ? (
                            <img
                              src={currentUser.profile_image}
                              alt="user"
                              className="w-8 h-8 rounded-full object-cover"
                            />
                          ) : (
                            <div className="w-8 h-8 rounded-full bg-purple-500 text-white flex items-center justify-center font-semibold text-sm">
                              {currentUser.name?.charAt(0).toUpperCase()}
                            </div>
                          )}
                          <div className="flex-1 flex flex-col">
                            <div className="flex items-center border rounded-full w-full py-2 px-4 text-sm focus-within:ring-1 focus-within:ring-blue-500">
                              <input
                                ref={(el) =>
                                  (replyInputRefs.current[replyingTo] = el)
                                }
                                type="text"
                                value={replyText}
                                onChange={(e) => setReplyText(e.target.value)}
                                placeholder="Add a comment..."
                                className="flex-1 outline-none bg-transparent"
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" && !e.shiftKey) {
                                    e.preventDefault();
                                    handleCommentSubmit(e);
                                  }
                                }}
                              />
                              <div className="relative flex items-center gap-2">
                                <button
                                  type="button"
                                  onClick={() =>
                                    setShowReplyEmojiPicker(!showEmojiPicker)
                                  }
                                  className="text-gray-500 hover:text-gray-700"
                                >
                                  😊
                                </button>
                                {showReplyEmojiPicker && (
                                  <EmojiPickerWrapper
                                    onEmojiSelect={(emoji) =>
                                      setReplyText((prev) => prev + emoji)
                                    }
                                    onClose={() =>
                                      setShowReplyEmojiPicker(false)
                                    }
                                    positionClass="absolute bottom-10 right-0"
                                    inputRef={{
                                      current:
                                        replyInputRefs.current[replyingTo],
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                            <div className="flex justify-end mt-2">
                              <button
                                type="button"
                                onClick={() => setReplyingTo(null)}
                                className="text-gray-600 text-sm px-3 py-1 rounded-md hover:bg-gray-100 mr-2"
                              >
                                Cancel
                              </button>
                              <button
                                type="submit"
                                disabled={!replyText.trim()}
                                className="bg-blue-600 text-white text-sm px-3 py-1 rounded-md hover:bg-blue-700 disabled:bg-blue-300"
                              >
                                Post
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              ))}

            {comments.length > 2 && (
              <div className="pt-2">
                <button
                  onClick={() => setShowAllComments(!showAllComments)}
                  className="w-full text-center text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors"
                >
                  <div className="inline-flex items-center px-4 py-1.5 rounded-full hover:bg-gray-100">
                    {showAllComments ? (
                      <>
                        <MdKeyboardArrowUp className="mr-1 text-lg" />
                        Show fewer comments
                      </>
                    ) : (
                      <>
                        <MdKeyboardArrowDown className="mr-1 text-lg" />
                        Show {comments.length - 2} more{" "}
                        {comments.length - 2 === 1 ? "comment" : "comments"}
                      </>
                    )}
                  </div>
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {showEditPostModal && (
        <EditPostModal
          open={showEditPostModal}
          pollData={pollData}
          groupData={groupdata}
          type={"poll"}
          onClose={() => setShowEditPostModal(false)}
        />
      )}
    </div>
  );
};
export default LinkedInPoll;
